import { AttomDataType } from 'data/types';

export function getAttomSquareFootage(
  attomData: AttomDataType | null
): number | null {
  const bldgSize = attomData?.building?.size?.bldgSize;
  const livingSize = attomData?.building?.size?.livingSize;

  if (bldgSize != null && bldgSize > 0) {
    return bldgSize;
  }
  if (livingSize != null && livingSize > 0) {
    return livingSize;
  }
  return null;
}
